// export const  parseImg = (img) => new Promise((resolve) => {
//   const reader = new FileReader();
//   reader.readAsDataURL(img);
//   reader.onload = (e) => {
//     resolve(e.target.result);
//   };
// });

export const parseImg = file => {
  const result = window.URL.createObjectURL(file);
  if (typeof result === 'string') {
    return result;
  }

  throw new Error(`Failed to get string from the file reader`);
};
